import { useIntl } from 'react-intl'

import { Title } from 'mailup-web-components'

import styled from '@emotion/styled'
import { EditTemplateButtons } from './EditTemplateButtons'

const StyledHeader = styled.div`
  position: relative;
  width: 100%;
  height: 60px;
  padding: 10px;
  background: var(--pure-white);
  border-bottom: 1px solid var(--silver);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

const StyledText = styled.span`
  color: var(--boulder);
  margin-left: 8px;
`

export const HeaderEditMessage = () => {
  const intl = useIntl()

  return (
    <>
      <StyledHeader>
        <Title data-mu-test='header-campain-full-title'>
          {intl.formatMessage({
            id: 'Load.ContentsCampaignWizard.Step2TabEmail'
          })}
          :{' '}
          <StyledText>
            {intl.formatMessage({
              id: 'Load.ContentsCampaignWizard.TemplateTitle'
            })}
          </StyledText>
        </Title>
        <EditTemplateButtons />
      </StyledHeader>
    </>
  )
}
